import API from '../apiCreate'
import type { EmptyResponse } from '../types/base.types'
import type {
  CrmMessageAutomationSavePayload,
  ResponseCrmMessageAutomation,
  ResponseCrmMessageAutomationChannels,
  ResponseCrmMessageAutomationDeliveryTypes,
  ResponseCrmMessageAutomationEmailProviders,
  ResponseCrmMessageAutomationRecipientTypes,
  ResponseCrmMessageAutomations,
} from '../types/crm/crmMessageAutomation.types'

/** Автоматизация сообщений: `/v1/crm-message-automation/*`. */
export const crmMessageAutomationApi = {
  getList: () =>
    API.get<ResponseCrmMessageAutomations>('crm-message-automation'),
  getOne: (id: number) =>
    API.get<ResponseCrmMessageAutomation>(
      `crm-message-automation/view?id=${id}`,
    ),
  getChannels: () =>
    API.get<ResponseCrmMessageAutomationChannels>(
      'crm-message-automation/channels',
    ),
  getDeliveryTypes: () =>
    API.get<ResponseCrmMessageAutomationDeliveryTypes>(
      'crm-message-automation/delivery-types',
    ),
  getEmailProviders: () =>
    API.get<ResponseCrmMessageAutomationEmailProviders>(
      'crm-message-automation/email-providers',
    ),
  getRecipientTypes: () =>
    API.get<ResponseCrmMessageAutomationRecipientTypes>(
      'crm-message-automation/recipient-types',
    ),
  save: (data: CrmMessageAutomationSavePayload, id?: number) =>
    id
      ? API.post<ResponseCrmMessageAutomation>(
          `crm-message-automation/save?id=${id}`,
          data,
        )
      : API.post<ResponseCrmMessageAutomation>(
          'crm-message-automation/save',
          data,
        ),
  delete: (id: number) =>
    API.delete<EmptyResponse>(`crm-message-automation/delete?id=${id}`),
  reorderChannels: (id: number, channelIds: number[]) =>
    API.post<EmptyResponse>(`crm-message-automation/reorder?id=${id}`, {
      channel_ids: channelIds,
    }),
}
